import { render, staticRenderFns } from "./Workshop.vue?vue&type=template&id=9fe5ace8&scoped=true&"
import script from "./Workshop.vue?vue&type=script&lang=js&"
export * from "./Workshop.vue?vue&type=script&lang=js&"
import style0 from "./Workshop.vue?vue&type=style&index=0&id=9fe5ace8&lang=scss&scoped=true&"
import style1 from "./Workshop.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe5ace8",
  null
  
)

export default component.exports